import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { getMaintenanceScheduleSlots } from "../../../common/services/maintenance-schedule.api";
import SelectFormik from "../../../common/components/form/SelectFormik";
import { useToastContext } from "../../../common/components/ui/toast/toast.context";

const TimeSlotSelector = () => {
  const [availableSlots, setAvailableSlots] = useState<{ time: string, available: number }[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values, setFieldValue } = useFormikContext<any>();
  const { notifyError } = useToastContext();

  useEffect(() => {
    setFieldValue('scheduledTime', '');

    if (values.scheduledDate) {
      setIsLoading(true);
      getMaintenanceScheduleSlots(values.scheduledDate, values.typeReview)
        .then(response => {
          if (response.ok && response.data) {
            setAvailableSlots(response.data["availableSlots"] || []);
          } else {
            notifyError(response.message || "Tente novamente mais tarde.");
          }
        })
        .catch(error => {
          notifyError(error.message || "Tente novamente mais tarde.");
          console.error("Falha ao buscar horários:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setAvailableSlots([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.scheduledDate, values.typeReview, setFieldValue]);

  const timeOptions = availableSlots
    .filter(slot => slot["isAvailable"])
    .map(slot => ({
      label: slot.time,
      value: slot.time
    }));

  if (!values.scheduledDate) {
    return (
      <SelectFormik
        label="Horário disponível:"
        name="scheduledTime"
        defaultValue="Selecione uma data para ver os horários disponíveis"
        options={["Selecione uma data para ver os horários disponíveis"]}
        className="w-full"
        required={true}
      />
    );
  }

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        <span className="text-blue-500">Carregando horários...</span>
      </div>
    );
  }

  if (timeOptions.length === 0 && !isLoading && values.scheduledDate) {
    return (
      <SelectFormik
        label="Horário disponível:"
        name="scheduledTime"
        defaultValue="Não há horários disponíveis para esta data"
        options={["Não há horários disponíveis para esta data"]}
        className="w-full"
        required={true}
      />
    );
  }

  return (
    <SelectFormik
      label="Horário disponível:"
      name="scheduledTime"
      options={
        availableSlots
          .filter(slot => slot["isAvailable"])
          .map(slot => `${slot.time} (disponível)`)
      }
      className="w-full"
      required={true}
    />
  );
}

export default TimeSlotSelector;